import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

/**
 * Export data to Excel (.xlsx)
 * @param {{ columns: {header:string, key:string}[], rows: object[], fileName: string }} opts
 */
export function exportToExcel({ columns, rows, fileName }) {
  const header = columns.map((c) => c.header);
  const data = rows.map((r) => columns.map((c) => r[c.key] ?? ""));
  const ws = XLSX.utils.aoa_to_sheet([header, ...data]);

  // Auto-size columns
  ws["!cols"] = columns.map((c) => ({
    wch: Math.max(
      c.header.length,
      ...data.map((row) => String(row[columns.indexOf(c)] ?? "").length),
      12,
    ),
  }));

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Data");
  XLSX.writeFile(wb, `${fileName}.xlsx`);
}

/**
 * Export data to PDF
 * @param {{ columns: {header:string, key:string}[], rows: object[], fileName: string, title?: string }} opts
 */
export function exportToPDF({ columns, rows, fileName, title }) {
  const doc = new jsPDF({
    orientation:
      rows.length > 0 && columns.length > 6 ? "landscape" : "portrait",
  });

  if (title) {
    doc.setFontSize(14);
    doc.text(title, 14, 18);
  }

  autoTable(doc, {
    startY: title ? 26 : 14,
    head: [columns.map((c) => c.header)],
    body: rows.map((r) => columns.map((c) => r[c.key] ?? "")),
    styles: { fontSize: 8, cellPadding: 2 },
    headStyles: { fillColor: [39, 39, 42], textColor: 255 },
    alternateRowStyles: { fillColor: [249, 250, 251] },
    margin: { left: 10, right: 10 },
  });

  doc.save(`${fileName}.pdf`);
}
